module.exports = __webpack_public_path__ + "static/media/nav-logo.8f702c2c.svg";